export const learning_group_img = {
  alt: 'learning group',
  mobileImgData: {
    src:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-website/NewHome/png/learning_group.png',
    webpSrc:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-website/NewHome/webp/learning_group_136x136.webp',
  },
};

export const login_logo = {
  alt: 'nasacademy login',
  mobileImgData: {
    src: 'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/na-black.svg',
    webpSrc:
      'https://d2oi1rqwb0pj00.cloudfront.net/na-website/svg/na-black.svg',
  },
};
